import script from "./VideoCall.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCall.vue?vue&type=script&setup=true&lang=js"

import "./VideoCall.vue?vue&type=style&index=0&id=44199ce8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44199ce8"]])

export default __exports__